import * as types from 'store/mutation-types'
import api from 'store/api'
import Vue from 'vue'

const state = {
    formDisplayed: false,
    declaration: null,
    inpiDocuments: [],
    beneficialOwners: [],
    ownerCreationForm: null,
    ownerEditionForm: null
}

const mutations = {
    [types.BENEFICIAL_OWNERS_UPDATE_FORM_DISPLAYED_VALUE](state, payload) {
        Vue.set(state, 'formDisplayed', payload)
    },
    [types.BENEFICIAL_OWNERS_DECLARATION_FETCHED](state, payload) {
        Vue.set(state, 'declaration', payload.beneficial_owners_declaration)
    },
    [types.BENEFICIAL_OWNERS_INPI_DOCUMENTS_FETCHED](state, payload) {
        Vue.set(state, 'inpiDocuments', payload.inpi_rbe_documents)
    },
    [types.BENEFICIAL_OWNERS_LIST_FETCHED](state, payload) {
        Vue.set(state, 'beneficialOwners', payload.beneficial_owners)
    },
    [types.BENEFICIAL_OWNER_CREATION_FORM_FETCHED](state, payload) {
        Vue.set(state, 'ownerCreationForm', payload.form)
    },
    [types.BENEFICIAL_OWNER_EDITION_FORM_FETCHED](state, payload) {
        Vue.set(state, 'ownerEditionForm', payload.form)
    }
}

const actions = {
    broadcastFormDisplay({ commit }) {
        commit(types.BENEFICIAL_OWNERS_UPDATE_FORM_DISPLAYED_VALUE, true)
    },
    
    broadcastFormHide({ commit }) {
        commit(types.BENEFICIAL_OWNERS_UPDATE_FORM_DISPLAYED_VALUE, false)
    },

    fetchBeneficialOwnersDeclaration({ commit }, customerId) {
        const params = {
            with: 'activity_log.user'
        }

        return api.getBeneficialOwnersDeclaration(customerId, params)
            .then(response => commit(types.BENEFICIAL_OWNERS_DECLARATION_FETCHED, response.data))
    },

    updateBeneficialOwnersDeclaration({ commit }, declaration) {
        const customerId = declaration.customer_id

        return api.updateBeneficialOwnersDeclaration(customerId, declaration)
            .then(response => this.dispatch('beneficialOwners/fetchBeneficialOwnersDeclaration', customerId))
    },
    
    fetchInpiDocuments({ commit }, declarationId) {
        const params = {
            statuses: ['pending-validation'],
            paginate: 0
        }

        return api.getInpiDocument(declarationId, params)
            .then(response => commit(types.BENEFICIAL_OWNERS_INPI_DOCUMENTS_FETCHED, response.data))
    },

    updateInpiDocument({ commit }, document) {
        const declarationId = document.beneficial_owners_declaration_id

        return api.updateInpiDocument(declarationId, document)
            .then(response => {
                this.dispatch('beneficialOwners/fetchInpiDocuments', declarationId)

                if (state.declaration) {
                    this.dispatch('beneficialOwners/fetchBeneficialOwnersDeclaration', state.declaration.customer_id)
                }
            })
    },
    
    fetchBeneficialOwners({ commit }, declarationId) {
        const params = {
            paginate: 0
        }

        return api.getBeneficialOwners(declarationId, params)
            .then(response => commit(types.BENEFICIAL_OWNERS_LIST_FETCHED, response.data))
    },
    
    fetchBeneficialOwnerCreationForm({ commit }, declarationId) {
        return api.getBeneficialOwnerCreationForm(declarationId, {})
            .then(response => commit(types.BENEFICIAL_OWNER_CREATION_FORM_FETCHED, response.data))
    },
    
    storeBeneficialOwner({ commit }, owner) {
        const declarationId = owner.beneficial_owners_declaration_id

        return api.storeBeneficialOwner(declarationId, owner)
            .then(response => {
                this.dispatch('beneficialOwners/fetchBeneficialOwners', declarationId)

                if (state.declaration) {
                    this.dispatch('beneficialOwners/fetchBeneficialOwnersDeclaration', state.declaration.customer_id)
                }
            })
    },
    
    fetchBeneficialOwnerEditionForm({ commit }, params) {
        return api.getBeneficialOwnerEditionForm(params.declarationId, params.ownerId, {})
            .then(response => commit(types.BENEFICIAL_OWNER_EDITION_FORM_FETCHED, response.data))
    },
    
    updateBeneficialOwner({ commit }, owner) {
        const declarationId = owner.beneficial_owners_declaration_id

        return api.updateBeneficialOwner(declarationId, owner.id, owner)
            .then(response => {
                this.dispatch('beneficialOwners/fetchBeneficialOwners', declarationId)

                if (state.declaration) {
                    this.dispatch('beneficialOwners/fetchBeneficialOwnersDeclaration', state.declaration.customer_id)
                }
            })
    },

    deleteBeneficialOwner({ commit }, owner) {
        const declarationId = owner.beneficial_owners_declaration_id

        return api.deleteBeneficialOwner(declarationId, owner)
            .then(response => {
                this.dispatch('beneficialOwners/fetchBeneficialOwners', declarationId)

                if (state.declaration) {
                    this.dispatch('beneficialOwners/fetchBeneficialOwnersDeclaration', state.declaration.customer_id)
                }
            })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./client/store/modules/beneficialOwners.js